import React, { useState, useRef, } from "react";
import { Button } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { notifyMeForSecondaryMarketPlace } from "../../store/reducer/notifyMeSlice";
import "./OpeningBanner.scss";
import NotifyMeModal from "../NotifyMeModal/NotifyMeModal";

const OpeningBanner = () => {
  const loading = useSelector((state) => state.notifyMeSlice.loading);
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [newsLetterChecked, setNewsLetterChecked] = useState(false);
  const dispatch = useDispatch();
  const userProfileData = useSelector((state) => state.userData.userData);

  const formRef = useRef();

  const handleSendNotification = async (value) => {
    await dispatch(
      notifyMeForSecondaryMarketPlace(
        Object.keys(userProfileData).length
          ? {
              onSuccess: () => {
                setOpen(false);
                setEmail("");
                setNewsLetterChecked(false);
                formRef?.current?.resetFields();
              } 
            }
          : { 
            signUpForNewsletter: newsLetterChecked, 
            email: value.email,
            onSuccess: () => {
              setOpen(false);
              setEmail("");
              setNewsLetterChecked(false);
              formRef?.current?.resetFields();
            } 
          }
      )
    );
  };

  return (
    <div className="opening-banner-wrapper">
      <div className="container-fluid">
        <div className="opening-banner">
          <div className="opening-banner__content">
            <h4>Realbricks Secondary Market Opening Soon!</h4>
            <p>
            With our Realbricks Secondary Market, investors will gain access to liquidity for their real estate assets. You'll be able to buy and sell shares directly with other users on the platform, providing greater flexibility and control over your investments.
            </p>
            <Button
              className="no-focus"
              onClick={() => {
                Object.keys(userProfileData).length
                  ? handleSendNotification()
                  : (setOpen(true) || formRef.current.resetFields())
              }}
              loading={Object.keys(userProfileData).length ? loading : false}
              ghost
            >
              Get Notified
            </Button>
          </div>
        </div>
      </div>
       <NotifyMeModal
        open={open}
        setOpen={setOpen}
        email={email}
        setEmail={setEmail}
        newsLetterChecked={newsLetterChecked}
        setNewsLetterChecked={setNewsLetterChecked}
        handleNotifyMe={handleSendNotification}
        ref={formRef}
        loading={loading}
      />
    </div>
  );
};

export default OpeningBanner;
